import { View } from "./view";
import { useViewModel } from "./viewModel";

export default function ManageBookings() {
  const viewModel = useViewModel();
  return <View {...viewModel} />;
}
